import {useTranslation} from "react-i18next"
import {useEcpWorkflowContext} from "../../reactContext/contextCustomHooks/useEcpWorkflowContext"
import plusRedIcon from "../../assets/icon/plus-red.svg"

export default function AddGlossaryTerm() {
    const {t} = useTranslation()
    const {setEcpWorkflowAction} = useEcpWorkflowContext()

    const handleClick = () => {
        setEcpWorkflowAction({type: "ECP_WORKFLOW_IS_GLOSSARY_MODAL", payload: {isGlossaryModal: {modal: true, type: "add", index: null}}})
    }

    return (
        <>
         <li className="add-glossary-term" onClick={handleClick}>
            <span><img src={plusRedIcon} alt=""/>{t(`Add a term to the glossary`)}</span>
        </li>
        </>
    )
}